import XEUtils from 'xe-utils/methods/xe-utils';
import httpService from '@/service/http-service';
import BASE_API from '@/api/dataBase';

export default {
  // 格式化是/否Y/N
  yesOrNo({ cellValue }) {
    return cellValue ? (cellValue === 'Y' ? '是' : '否') : '否';
  },
  // 格式化性别
  formatSex({ cellValue }) {
    return cellValue ? (cellValue === '1' ? '男' : '女') : '';
  },
  // 格式化下拉选项
  formatSelect({ cellValue }, list) {
    const item = list.find((item) => item.value === cellValue);
    return item ? item.label : '';
  },
  // 格式化日期，默认 yyyy-MM-dd HH:mm:ss
  formatDate({ cellValue }, format) {
    return XEUtils.toDateString(cellValue, format || 'yyyy-MM-dd HH:mm:ss');
  },
  // 格式金额，默认2位数
  formatAmount({ cellValue }, digits) {
    return XEUtils.commafy(cellValue, { digits: digits || 2 });
  },
  // 格式化银行卡，默认每4位隔开
  formatBankcard({ cellValue }) {
    return XEUtils.commafy(cellValue, { spaceNumber: 4, separator: ' ' });
  },
  // 四舍五入,默认两位数
  formatFixedNumber({ cellValue }, digits) {
    return XEUtils.toNumber(cellValue).toFixed(digits || 2);
  },
  // 截取小数,默认两位数
  formatCutNumber({ cellValue }, digits) {
    return XEUtils.toFixedString(cellValue, digits || 2);
  },
  // 转换 moment 类型为字符串
  toMomentString({ cellValue }, format) {
    return cellValue ? cellValue.format(format) : '';
  },

  // 字典 格式化
  dictCodeToName({ cellValue, column }) {
    let dictList = JSON.parse(localStorage.getItem('dictList'));
    let dictLabel = cellValue;
    if (!dictList[column.params.type]) {
      ajaxDictLabel(column.params.type, cellValue);
      // let result = await httpService.post(BASE_API.DIC_CREDIT_API,{dictType:column.params.type})
      // return "4444"
      // dictLabel = cellValue
    } else {
      dictLabel = dictList[column.params.type][cellValue];
      if (!dictLabel) dictLabel = cellValue;
    }
    return dictLabel;
  },
};

//根据dictType接口查询dictList
function ajaxDictLabel(type, cellValue) {
  httpService.post(BASE_API.DIC_CREDIT_API, { dictType: type }).then((result) => {
    if (0 == result.data.code) {
      let data = result.data.data;
      if (data[0]) {
        return result.data.data[cellValue];
      } else {
        return '4444';
      }
    } else {
      return '33333';
    }
  });
  //字典缺失
  // let result = await httpService.get(BASE_API.DIC_CREDIT_API,{dictType:column.params.type});
  // if (0 == result.data.code) {
  //   dictLabel = result[cellValue]
  //   if(!dictLabel) dictLabel = cellValue
  // }
}
